module.exports = __webpack_public_path__ + "img/IL.f85b297f.png";